import { tv } from "../../../variants/tv.js";
const glowEffectWrapperVariants = tv({
    slots: {
        wrapperSlot: 'relative p-2',
        contentSlot: 'pointer-events-none absolute inset-0 z-[-1] opacity-0',
        glowSlot: ''
    }
});
export { glowEffectWrapperVariants };
